import { ANALYTICS_PATH } from './analytics';

const ROOT_PATH = `${ANALYTICS_PATH}/area-shortage` as const;

export const ROOT = {
  PATH: ROOT_PATH,
  toPath: () => ROOT_PATH,
};
